import NRAssetRiskChanged from '../../NRAssetRiskChanged/NRAssetRiskChanged';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock } from '../activityFeedHeaderShared';

function AssetRiskChangedHeader({ entity, item, activity }) {
  return (
    <HeaderBlock
      primary={
        <DefaultPrimaryHeader
          label={entity?.name}
          activity={activity}
          endAdornment={
            <NRAssetRiskChanged sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }} oldRisk={entity.oldRisk} newRisk={entity.newRisk} />
          }
        />
      }
      secondary={<DescriptionSecondary item={item} />}
    />
  );
}

export default AssetRiskChangedHeader;
